let load = require('./helpers/browser/esm-js-loader');
module.exports = (load("hzekf")).then(() => parcelRequire('4fX4g'));